<template>
  <div>
    <h3 class="account-sub-title d-none d-md-block mt-0 pt-1 ml-1">
      <i class="icon-user-2 align-middle mr-3 pr-1"></i>{{ translations.accountDetails }}
    </h3>
    <div class="account-content">
      <form @submit.prevent.stop="submitForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="first-name">{{ translations.forms.labels.firstName }}
                <span class="required">*</span></label>
              <input
                v-model="profile.userData.firstName"
                type="text"
                class="form-control mw-100"
                placeholder="Ime"
                id="first-name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="last-name">{{ translations.forms.labels.lastName }}
                 <span class="required">*</span> </label>
              <input
                v-model="profile.userData.lastName"
                type="text"
                class="form-control mw-100"
                id="last-name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="last-name">{{ translations.forms.labels.country }}
                 <span class="required">*</span> </label>
              <div class="select-custom mw-100">
                <select
                  class="form-control mw-100"
                  v-model="profile.userData.countryId"
                  @change="onCountryChange"
                >
                  <option :value="null">{{ translations.chooseCountry }}</option>
                  <option :value="country.id" v-for="country in countries" :key="country.id">
                    {{ country.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="last-name">{{ translations.forms.labels.town }}
                <span class="required">*</span> </label>
              <div class="select-custom mw-100">
                <select class="form-control mw-100" v-model="profile.userData.townId">
                  <option :value="null">{{ translations.chooseTown }}</option>
                  <option :value="town.id" v-for="town in towns" :key="town.id">
                    {{ town.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="zip-code">{{ translations.zipCode }}
                 <span class="required">*</span> </label>
              <input
                v-model="profile.userData.zipCode"
                type="text"
                class="form-control mw-100"
                id="zip-code"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="address">{{ translations.forms.labels.address }}
                 <span class="required">*</span> </label>
              <input
                v-model="profile.userData.address_1"
                type="text"
                class="form-control mw-100"
                id="addres"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="phone">{{ translations.phoneNumber }}
                 <span class="required">*</span> </label>
              <input
                v-model="profile.userData.phoneNumber"
                type="text"
                class="form-control mw-100"
                id="phone"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="email">{{ translations.emailAddress }}
                <span class="required">*</span></label>
              <input
                v-model="profile.userData.email"
                type="text"
                class="form-control mw-100"
                id="email"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="last-name">{{ translations.areasOfInterest }}
                 <span class="required">*</span> </label>
              <treeselect
                class="mw-100"
                v-model="profile.userData.interestsAreas"
                :multiple="true"
                :options="areas"
                :placeholder="translations.chooseAreaOfInterest"
              />
            </div>
          </div>
        </div>
        <div class="form-footer mt-3 mb-0">
          <button type="submit" class="btn btn-primary mr-0">
            {{ translations.sendRequest }}
          </button>
        </div>
      </form>

      <form @submit.prevent.stop="changePassword">
        <div class="change-password">
          <h3 class="text-uppercase mb-2">{{ translations.changePassword }}</h3>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-danger': $v.currentPassword.$anyError }">
                <label for="password">
                  {{ translations.currentPassLeaveBlank }}
                </label>
                <input
                  type="password"
                  class="form-control mw-100"
                  id="password"
                  v-model="currentPassword"
                />

                <form-error
                  :model="$v.currentPassword"
                  :dirty="$v.$dirty"
                  :label="translations.oldPassword"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-danger': $v.newPassword.$anyError }">
                <label for="new-password">
                  {{ translations.newPassLeaveBlank }}
                </label>
                <input
                  type="password"
                  class="form-control mw-100"
                  id="new-password"
                  v-model="newPassword"
                />

                <form-error
                  :model="$v.newPassword"
                  :dirty="$v.$dirty"
                  :label="translations.newPassword"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{ 'has-danger': $v.confirmPassword.$anyError }">
                <label for="confirm-password">{{ translations.confirmNewPassword }}</label>
                <input
                  type="password"
                  class="form-control mw-100"
                  id="confirm-password"
                  v-model="confirmPassword"
                />
                <form-error
                  :model="$v.confirmPassword"
                  :dirty="$v.$dirty"
                  :label="translations.passwordConfirmation"
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="form-footer d-flex justify-content-between mt-3 mb-0">
            <button type="submit" class="btn btn-primary mr-0">
            {{ translations.save }}
          </button>
            <button @click.prevent="showDeleteUserModal" class="btn btn-danger mr-0">
              {{ translations.deleteUserAcc }}
            </button>
          </div>
          <div class="d-flex justify-content-end align-items-end mt-1">
            <span>
              *{{ translations.permanentlyDeletedAcc }}
            </span>
          </div>
        </div>
      </form>
    </div>
    <modal id="deleteUserModal" >
        <div slot="header" class="card-header">
          {{ translations.warning }}!
        </div>
        <div slot="body" class="card-body">
          <h4 class="font-weight-bold text-dark"><i class="fas fa-question-circle">
          </i> {{ translations.attention }}!</h4>
          <div class="modal-text">
            <p>{{ translations.areYouSureYouWantToDeleteAcc }}</p>
            <input
                  type="password"
                  class="form-control mw-100"
                  id="passwordToDeleteAcc"
                  v-model="passwordToDeleteAccount"
                />
          </div>
        </div>
        <div slot="footer" class="card-footer">
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-default modal-dismiss me-2"
              @click="closeDeleteUserModal"
            >
              {{ translations.cancel2 }}
            </button>
            <button
              class="btn btn-primary modal-confirm ml-3"
              @click="deleteUser"
            >
              {{ translations.delete2 }}
            </button>
          </div>
        </div>
      </modal>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Modal from '@/components/shared/modal/Modal.vue';
import { translations } from '@/mixins';
import api from '@/services/api';
import FormError from '@/components/shared/form-errors/FormError.vue';
import validations from './validation-schema/updatePassword';

export default {
  name: 'AccountDetails',
  mixins: [translations],
  validations,
  components: {
    Treeselect,
    FormError,
    Modal,
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordToDeleteAccount: '',
    };
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries;
    },
    towns() {
      return this.$store.getters.getTowns;
    },
    areas() {
      return this.$store.getters.getInterestsAreas.map((item) => ({
        id: item.id,
        label: item.title,
      }));
    },
    profile() {
      return this.$store.getters.getProfile;
    },
  },
  methods: {
    showDeleteUserModal() {
      $('#deleteUserModal').modal('show');
    },
    closeDeleteUserModal() {
      $('#deleteUserModal').modal('hide');
    },
    deleteUser() {
      api.checkPasswordToDeleteAcc(this.passwordToDeleteAccount)
        .then((response) => {
          if (response.data.data) {
            this.closeDeleteUserModal();
            api.deactivateUser()
              .then((response2) => {
                this.$toast.info(response2.data.info);
                if (response2.data.isValid) {
                  localStorage.removeItem('token');
                  this.$router.push({ name: 'Home' }).then(() => {
                    window.location.reload();
                  });
                }
              })
              .catch((err) => {
                if (err.response && err.response.data && err.response.data.info) {
                  this.$toast.error(err?.response?.data?.info);
                } else {
                  this.$toast.error('An error occurred while deactivating the account.');
                }
              });
          } else {
            this.$toast.error('Pogrešna lozinka');
          }
        })
        .catch(() => {
          this.$toast.error('Pogrešna lozinka');
        });
    },
    onCountryChange() {
      this.profile.townId = null;
      this.$store.dispatch('getTowns', {
        sortBy: 'title',
        isSortAscending: false,
        retrieveAll: true,
        countryId: this.profile.countryId,
      });
    },
    submitForm() {
      const {
        firstName,
        lastName,
        address_1,
        phoneNumber,
        townId,
        countryId,
        interestsAreas,
        zipCode,
      } = this.profile.userData;

      const payload = {
        firstName,
        lastName,
        townId,
        countryId,
        zipCode,
        address: address_1,
        phoneNumber,
        interestsAreas,
      };

      api.updateProfile(payload).then((response) => {
        this.$toast.info(response.data?.info || 'Profil uspješno ažuriran');
      }).catch((err) => {
        this.$toas.error(err.response.data.info);
      });
    },
    changePassword() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const payload = {
        currentPassword: this.currentPassword,
        password: this.newPassword,
      };

      api.updatePassword(payload).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      }).finally(() => {
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.$v.$reset();
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getCountries', {
      sortBy: 'title',
      isSortAscending: false,
      retrieveAll: true,
    });
    this.$store.dispatch('getTowns', {
      sortBy: 'title',
      isSortAscending: false,
      retrieveAll: true,
    });
    this.$store.dispatch('getInterestsAreas', {
      sortBy: 'title',
      isSortAscending: false,
      retrieveAll: true,
    });
  },
};
</script>
<style lang="scss">
.vue-treeselect__control {
  max-width: 100% !important;
  height: 46px;
  border-radius: 0;
}

.vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
  line-height: 44px;
}

.vue-treeselect__multi-value-item {
  height: 34px;
}

.has-danger .form-control {
  border-color: #d2322d !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
}

</style>
